export enum REQUEST_TYPES {
	DO_GET_COOKIES_CONFIG = 'DO_GET_COOKIES_CONFIG',
	DO_UPDATE_COOKIES_CONFIG = 'DO_UPDATE_COOKIES_CONFIG'
}


